/*
 * Date: 2023-07-17
 * Description: Main menu component
 * Author: Philippe Leroux @ skitsc
 */

//Modules
import { Box } from "@mui/material";

//Menus
import SideBar from "./sidebar.menu";
import TopBar from "./topbar.menu";

//Components
import ScrollToTop from "../utility/scroll.top";

//Styles
import { app , content , main_container } from "../../styles/main.styles";

//Types && Interfaces
import { i_child_component } from "../../interfaces/utility.interface";

const UI = ({ MyComponent , mobile} : i_child_component) => {
    return (
        <Box component={'div'} sx={app}>
            <SideBar />
            <Box component={'main'} sx={content}>
                <TopBar />
                <Box sx={main_container} component={'div'} id="back-to-top-anchor">
                    {MyComponent}
                    <ScrollToTop/>
                </Box>
            </Box>
        </Box>
    )
}

export default UI